import type { CountryCode, RefundView } from '@capsico/contracts';
import type { RefundRowView } from '../components/Payment';
import { money } from '../utils/money';
import { orderTime } from '../utils/format';
import type { Translate } from './index';

/** Restaurant-card copy shared by home and search. */
export function cardLabels(t: Translate) {
  return {
    forTwo: (amount: string) => t('home.forTwo', { amount }),
    legend: t('home.legend'),
    isNew: t('home.newBadge'),
    closed: t('home.closed'),
    has: (dishes: string) => t('search.matched', { dishes }),
  };
}

/** Refund row for the order page and Capsico Money (amounts in the order's country). */
export function refundRowView(
  t: Translate,
  country: CountryCode,
  refund: RefundView,
  orderNumber?: string,
): RefundRowView {
  const reason = t(`refund.reason.${refund.reason}`);
  return {
    id: refund.id,
    amount: money(country, refund.amountMinor),
    reason: orderNumber ? `${reason} · ${t('orders.number', { number: orderNumber })}` : reason,
    destination: refund.destination
      ? t(refund.destination === 'wallet' ? 'refund.toWallet' : 'refund.toSource')
      : null,
    status: t(`refund.status.${refund.status}`),
    tone:
      refund.status === 'done'
        ? 'positive'
        : refund.status === 'failed'
          ? 'negative'
          : refund.status === 'awaiting_choice'
            ? 'warning'
            : 'neutral',
    choice:
      refund.status === 'awaiting_choice'
        ? {
            title: t('refund.choiceTitle', { amount: money(country, refund.amountMinor) }),
            walletLabel:
              refund.bonusMinor > 0
                ? t('refund.choiceWalletBonus', { amount: money(country, refund.bonusMinor) })
                : t('refund.choiceWallet'),
            walletHint: t('refund.choiceWalletHint'),
            sourceLabel: refund.sourceAllowed ? t('refund.choiceSource') : null,
            sourceHint: t('refund.choiceSourceHint'),
            deadline: refund.chooseBy
              ? t('refund.chooseBy', { time: orderTime(refund.chooseBy) })
              : null,
          }
        : null,
  };
}
